module.exports = __webpack_public_path__ + "img/doc.054ca804.png";